// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.categoryCard_container__jKzma {
  display: flex;
  width: 298px;
  height: 160px;
  padding: 15px 10px;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  flex-shrink: 0;
  border-radius: var(--Corner-radius, 4px);
  background: #FFF;
  box-shadow: 0px 0px 8px 0px rgba(42, 98, 149, 0.25);
  text-decoration: none;
  color: black;
  overflow-wrap: break-word;
  overflow: scroll;
  text-overflow: ellipsis; }

.categoryCard_titleContainer__1eGSg {
  display: flex;
  flex-direction: column;
  row-gap: 8px; }

.categoryCard_title__aDNmG {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px; }

.categoryCard_plainText__WKxbS {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px; }
`, "",{"version":3,"sources":["webpack://./src/pages/aiChat/components/categoryCard/categoryCard.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,8BAA8B;EAC9B,QAAQ;EACR,cAAc;EACd,wCAAwC;EACxC,gBAAgB;EAChB,mDAAmD;EACnD,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB,EAAA;;AAGzB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;ECTE,gBAAgB;EAChB,eAAe;EACf,iBAAiB,EAAA;;ADWnB;ECWE,gBAAgB;EAChB,eAAe;EACf,iBAAiB,EAAA","sourcesContent":["@import '../../../../styles/common.scss';\n@import '../../../../styles/fonts';\n\n.container {\n  display: flex;\n  width: 298px;\n  height: 160px;\n  padding: 15px 10px;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: var(--Corner-radius, 4px);\n  background: #FFF;\n  box-shadow: 0px 0px 8px 0px rgba(42, 98, 149, 0.25);\n  text-decoration: none;\n  color: black;\n  overflow-wrap: break-word;\n  overflow: scroll;\n  text-overflow: ellipsis;\n}\n\n.titleContainer {\n  display: flex;\n  flex-direction: column;\n  row-gap: 8px;\n}\n\n.title {\n  @include h4\n}\n\n.plainText {\n  @include body2;\n}","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `categoryCard_container__jKzma`,
	"titleContainer": `categoryCard_titleContainer__1eGSg`,
	"title": `categoryCard_title__aDNmG`,
	"plainText": `categoryCard_plainText__WKxbS`
};
export default ___CSS_LOADER_EXPORT___;
